// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".auth-code-embeded-wrapper{margin:24px;height:80vh;overflow-y:scroll}", "",{"version":3,"sources":["webpack://./src/views/auth/components/embeded-code/embeded-code.scss"],"names":[],"mappings":"AAAA,2BACC,WAAA,CACA,WAAA,CACA,iBAAA","sourcesContent":[".auth-code-embeded-wrapper {\n\tmargin: 24px;\n\theight: 80vh;\n\toverflow-y: scroll;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
